// Consistent spacing values
export const SPACING = {
  xs: 0.5,  // 4px
  sm: 1,    // 8px
  md: 2,    // 16px
  lg: 3,    // 24px
  xl: 4     // 32px
};

// Common style configurations
export const STYLES = {
  sectionMinHeight: 300,
  sidebarWidth: 250,
  maxContentWidth: 1900,
  breakpoints: {
    sidebarHide: 1600
  }
};

// Animation durations
export const TRANSITIONS = {
  sidebar: '0.3s ease-in-out',
  default: '0.2s ease'
};